import { paths as CustomerCommunicationPaths } from '@luxuryescapes/contract-customer-communication';

import { request } from '~/services/common';

import { makeCustomerCommunicationV1URL } from './customerCommunicationRequestUtils';
import { TodaysEscapesScheduleGenerationSegment } from './requestPostTodaysEscapesScheduleGeneration';

type TodaysEscapesScheduleGenerationStatusGetContract =
  CustomerCommunicationPaths['/api/customer-communication/v1/todays-escapes-schedule/schedules/status']['get'];

export type TodaysEscapesScheduleGenerationStatus =
  TodaysEscapesScheduleGenerationStatusGetContract['responses']['200']['content']['application/json']['result'];

export interface TodaysEscapesScheduleGenerationStatusParams {
  brand: string;
  countryGroup: string;
  /**
   * YYYY-MM-DD
   */
  sendDate: string;
  /** Lifestyle brands are checked per segment, like they're generated */
  segment?: TodaysEscapesScheduleGenerationSegment;
}

/**
 * The pre-send check the send itself runs: whether every identifier in the country group has a generated tail deals
 * schedule, hero planner rows weren't edited after generation, custom schedules are approved, and so on.
 */
async function requestGetTodaysEscapesScheduleGenerationStatus(
  { brand, countryGroup, sendDate, segment }: TodaysEscapesScheduleGenerationStatusParams,
  signal?: AbortSignal,
): Promise<TodaysEscapesScheduleGenerationStatus> {
  const url = makeCustomerCommunicationV1URL('/todays-escapes-schedule/schedules/status');
  url.searchParams.set('brand', brand);
  url.searchParams.set('countryGroup', countryGroup);
  url.searchParams.set('sendDate', sendDate);
  if (segment) {
    url.searchParams.set('segment', segment);
  }

  const response: TodaysEscapesScheduleGenerationStatusGetContract['responses']['200']['content']['application/json'] =
    await request(url.toString(), {
      method: 'GET',
      credentials: 'include',
      signal,
    });

  return response.result;
}

export default requestGetTodaysEscapesScheduleGenerationStatus;
